// Kubernetes' reasons for a pod, in words (2026-10-10): the Graph and Releases
// named pods "loki-0 (Unschedulable)" and a registry's last exit "OOMKilled
// (137)". What happened is said; the raw reason stays for the detail panel.
// Pure; tested in podWords.test.ts.

const WORDS: Record<string, string> = {
  OOMKilled: 'ran out of memory',
  Unschedulable: 'can’t be placed on a node',
  CrashLoopBackOff: 'keeps crashing',
  Error: 'stopped with an error',
  ImagePullBackOff: 'can’t get its image',
  ErrImagePull: 'can’t get its image',
  CreateContainerConfigError: 'is missing its settings',
  ContainerCreating: 'is starting',
  PodInitializing: 'is starting',
  Pending: 'is waiting to start',
  Evicted: 'was moved off its node',
  Completed: 'finished',
  DeadlineExceeded: 'ran out of time',
  NodeLost: 'lost its node',
}

/**
 * A pod's reason (or a container's last exit, "OOMKilled (137)") in words:
 * "ran out of memory". A reason it does not know is given as it is.
 */
export const podWords = (reason: string | undefined): string => {
  const r = (reason ?? '').trim()
  if (!r) return ''
  const bare = r.replace(/\s*\(\d+\)$/, '')
  return WORDS[bare] ?? r
}
